import { css } from '@emotion/react'
import { StyleModifier } from '../../primitives/modifiers/types'
import { ColorFamilyProps, ColorProperties } from '../../primitives/modifiers/color'

const colorPairStyle = (foreground: string, background: string) =>
	css({ backgroundColor: background, color: foreground })

const darkOnLight: StyleModifier<ColorFamilyProps> = ({ color }) => colorPairStyle(color.darker, color.lighter)

const whiteOnDark: StyleModifier<ColorFamilyProps> = ({ color }) => colorPairStyle('white', color.darker)

const definedOnColor = css({ color: ColorProperties.On })

export const ColorPairs = {
	darkOnLight,
	whiteOnDark,
	definedOnColor,
	...colorPairStyle
}
